import { render } from "./CatalogCartContainer.vue?vue&type=template&id=240a9ab2"
import script from "./CatalogCartContainer.vue?vue&type=script&lang=js"
export * from "./CatalogCartContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__